import React from 'react';
import { ReactComponent as SearchIcon } from '../../assets/search_icon.svg';
import './Search.css';

type SearchProps = {
  label?: string;
};

const Search: React.FC<SearchProps> = ({ label }) => {
  return (
    <div className="search">
      <SearchIcon className="search-icon" />
      {/* <span>{label}</span> */}
    </div>
  );
};

export default Search;
